import {
  SET_LIST_OF_VALUES_CLAIM_DOCUMENT,
  SET_BANK_EMPLOYEE_CODE,
  SET_BANK_REFFERER_CODE,
  SET_POLICY_PROVINCE,
} from '@stores/policy/constants.js';

export const initialState = {
  provincesData: [],
};

const policyReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_POLICY_PROVINCE:
      state = {
        ...state,
        provincesData: payload,
      };

      break;

    case SET_LIST_OF_VALUES_CLAIM_DOCUMENT:
      state = {
        ...state,
        lovList: payload,
      };

      break;

    case SET_BANK_EMPLOYEE_CODE:
      state = {
        ...state,
        bankEmployeeData: payload,
      };

      break;
    case SET_BANK_REFFERER_CODE:
      state = {
        ...state,
        bankReffererData: payload,
      };

      break;
    default:
      break;
  }
  return state;
};

export default policyReducers;
